var _style, _polygon, _polygon2, _polygon3, _polygon4, _defs, _path, _polygon5, _rect, _path2, _path3, _polygon6, _polygon7, _path4, _polygon8, _polygon9, _defs2, _path5, _polygon10, _path6, _defs3, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKreatizePartsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 507.94 42.76",
    style: {
      enableBackground: "new 0 0 507.94 42.76"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#929292;}\n\t.st1{fill:#646363;}\n\t.st2{fill:#24BBE7;}\n\t.st3{fill:#59BBA8;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#929292;}\n\t.st5{clip-path:url(#SVGID_4_);fill:#929292;}\n\t.st6{clip-path:url(#SVGID_6_);fill:#929292;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "487.72,15.14 495.25,19.48 506.37,10.66 487.72,0 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "485.87,0 467.22,14.7 478.34,21.11 485.87,15.14 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "465.66,31.16 485.87,42.72 485.87,27.58 465.66,15.92 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "487.72,27.58 487.72,42.72 507.94,26.78 507.94,11.54 "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 507.94,
    height: 42.76
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.21,15c0-8.91-4.79-12.63-14.68-12.63H35.64v40.35h6.27v-35h9.61c5.56,0,8.21,2.39,8.21,7.39 c0,4.66-2.07,7.74-8.15,7.74h-5.98l-1.6,5.35h8.35l7.16,14.51h6.92L58.57,26.7C63.75,24.83,66.21,21.17,66.21,15"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "138.82,2.36 138.82,7.72 150.15,7.72 150.15,42.72 156.49,42.72 156.49,7.72 167.69,7.72 167.69,2.36  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 172.85,
    y: 2.36,
    className: "st0",
    width: 6.27,
    height: 40.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197.72,37.37l-4.66,5.35h25.73v-5.35H197.72z M187.54,2.36v5.35h23.24l-25.62,29.42v5.58h2.91l30.41-34.95 V2.36H187.54z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.44,7.72h3.33l5.69,20.55h-14.81L121.44,7.72z M116.75,2.36l-11.51,40.4h6.27l2.78-9.08h17.46l2.91,9.02 H141L129.62,2.36H116.75z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "74.48,2.36 74.48,42.72 102.36,42.72 102.36,37.37 80.82,37.37 80.82,7.72 100.62,7.72 100.62,2.36 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "223.96,2.36 223.96,42.72 251.84,42.72 251.84,37.37 230.3,37.37 230.3,7.72 250.1,7.72 250.1,2.36 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,42.72h6.28V2.36H0V42.72z M21.66,2.36L8.33,21.96l14.18,20.76h7.33L15.34,21.96L28.77,2.36H21.66z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "84.49,19.28 82.95,24.64 96.18,24.64 97.75,19.28 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "233.97,19.28 232.43,24.64 245.66,24.64 247.23,19.28 "
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    y: 0,
    width: 507.94,
    height: 42.76
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M378.31,14.99c0-8.91-4.79-12.63-14.68-12.63h-15.89v40.35h6.27v-35h9.61c5.56,0,8.21,2.39,8.21,7.39 c0,4.66-2.07,7.74-8.15,7.74h-5.98l-1.6,5.35h8.35l7.16,14.51h6.92l-7.87-16.02C375.85,24.83,378.31,21.16,378.31,14.99"
  }))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "381.07,2.31 381.07,7.67 392.4,7.67 392.4,42.67 398.74,42.67 398.74,7.67 409.94,7.67 409.94,2.31 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.98,7.67h3.33L332,28.22h-14.81L322.98,7.67z M318.28,2.31l-11.51,40.4h6.27l2.78-9.08h17.46l2.91,9.02 h6.34L331.16,2.31H318.28z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    y: 0,
    width: 507.94,
    height: 42.76
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M439.39,2.39c0,0-7.66-1.41-12.79-1.41c-8.08,0-13.44,3.36-13.44,11.5c0,7.01,3.77,9.67,12.5,11.91 c6.19,1.47,8.02,2.65,8.02,6.07c0,4.24-2.3,6.49-7.31,6.49c-4.19,0-12.15-1.06-12.15-1.06l-0.65,5.25c0,0,7.96,1.59,13.21,1.59 c7.96,0,13.5-3.83,13.5-12.68c0-6.9-3.07-9.14-11.55-11.5c-6.9-1.89-9.02-2.77-9.02-6.54c0-3.48,2.54-5.25,7.49-5.25 c3.42,0,11.67,0.94,11.67,0.94L439.39,2.39z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M308.69,14.99c0-8.91-4.79-12.63-14.68-12.63h-15.89v40.35h6.27v-35h9.61c5.56,0,8.21,2.39,8.21,7.39 c0,4.66-2.07,7.74-8.15,7.74h-5.98l-1.6,5.35l7.46,0.01c4.64,0,8.93-1.34,11.59-4.25C307.66,21.88,308.69,18.96,308.69,14.99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKreatizePartsLogo);
export default __webpack_public_path__ + "static/media/kreatize_parts_logo.d07164c157761fad3ed209dfcdfad7fb.svg";
export { ForwardRef as ReactComponent };